(() => {
  const init = (root) => {
    const slides = [...root.querySelectorAll('.announcement-slide')];
    if (slides.length < 2 || root.dataset.ready) return;
    root.dataset.ready = 'true';
    let i = 0; let timer = null;
    const show = (n) => { slides[i].classList.remove('is-active'); i = (n + slides.length) % slides.length; slides[i].classList.add('is-active'); };
    const start = () => { if (timer || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return; timer = setInterval(() => show(i + 1), 4500); };
    const stop = () => { clearInterval(timer); timer = null; };
    const prev = root.querySelector('[data-announce-prev]'); const next = root.querySelector('[data-announce-next]');
    prev?.addEventListener('click', () => { stop(); show(i - 1); start(); });
    next?.addEventListener('click', () => { stop(); show(i + 1); start(); });
    root.addEventListener('mouseenter', stop); root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop); root.addEventListener('focusout', start);
    document.addEventListener('visibilitychange', () => { if (document.hidden) stop(); else start(); });
    start();
  };
  const run = (r = document) => r.querySelectorAll('[data-announcement]').forEach(init);
  run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();
